import orderRoutes from './orders'

export default [
  ...orderRoutes
]



// WEBPACK FOOTER //
// ./src/emktcommon/router/index.js